import {
    ECatalogStatus,
    ECatalogStatusType,
    ECatalogStatusTypes,
} from "./e-catalog-response";

function resolveStatusColor(type: ECatalogStatusType) {
    switch (type) {
        case ECatalogStatusTypes.FAILED:
            return "red"; // error
        case ECatalogStatusTypes.REQUESTED:
        case ECatalogStatusTypes.COLLECTING:
        case ECatalogStatusTypes.COLLECTED:
        case ECatalogStatusTypes.GENERATING:
        case ECatalogStatusTypes.GENERATED:
            return "dark-blue"; // in preparation
        case ECatalogStatusTypes.UPLOADED:
        case ECatalogStatusTypes.SENT:
        case ECatalogStatusTypes.DELIVERED:
        case ECatalogStatusTypes.AVAILABLE:
            return "green"; // available
        default:
            return "grey"; // unknown status
    }
}

const getStatusText = ({ type, text }: ECatalogStatus): string => {
    const statusColor = resolveStatusColor(type);
    return `<span class="ux-text-status ux-text-status--${statusColor}">
                <ux-icon name="circle-filled"></ux-icon>${text}
            </span>`;
};

export default getStatusText;
